
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useCurrency } from '../context/CurrencyContext';

const Cart = () => {
  const navigate = useNavigate();
  const { selectedCurrency } = useCurrency();
  const [cartdata, setCartdata] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [comments, setComments] = useState({});
  const [references, setReferences] = useState({});
  const [engravings, setEngravings] = useState({});

  const [activeView, setActiveView] = useState(localStorage.getItem("activeView") || "wholesale");
  const [viewVersion, setViewVersion] = useState(0);
 
  const [deliveryError, setDeliveryError] = useState("");
  const [applySameDate, setApplySameDate] = useState(false);
  const [previewImages, setPreviewImages] = useState({});
  const [uploadedFiles, setUploadedFiles] = useState({});

  useEffect(() => {
  const storedCart = JSON.parse(localStorage.getItem("cart")) || [];

  const updatedCart = storedCart.map(item => ({
    ...item,
    Deliverydate:
      item.Deliverydate && item.Deliverydate !== ""
        ? item.Deliverydate // ✅ keep user-selected date
        : getDeliveryDateByStock(item.InStock), // ✅ only default once
  }));

  setCartdata(updatedCart);
  localStorage.setItem("cart", JSON.stringify(updatedCart));
}, []);


  // LISTEN TO VIEW CHANGES
  useEffect(() => {
    const handleStorageChange = () => {
      const newView = localStorage.getItem("activeView") || "wholesale";
      setActiveView(newView);
      setViewVersion(v => v + 1);
    };

    const handleViewChange = (e) => {
      const newView = e.detail || localStorage.getItem("activeView") || "wholesale";
      setActiveView(newView);
      setViewVersion(v => v + 1);
    };

    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("viewChange", handleViewChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("viewChange", handleViewChange);
    };
  }, []);

  // APPLY MARKUP FUNCTION
  const applyMarkup = (basePrice) => {
    const view = localStorage.getItem("activeView") || "wholesale";
    if (view === "wholesale") return basePrice;

    const storedPayload = JSON.parse(localStorage.getItem("priceTable_seller") || "{}");
    const table = Array.isArray(storedPayload.data) ? storedPayload.data : [];
    if (!table.length) return basePrice;

    const range = table.find((r) => {
      const from = parseFloat(r.from || 0);
      const to = r.to === null ? Infinity : parseFloat(r.to);
      return basePrice >= from && basePrice <= to;
    });

    if (range) {
      const markupPercent = parseFloat(range.markup || 0);
      return basePrice * markupPercent;
    }

    return basePrice;
  };

  const updateQuantity = (index, newQuantity) => {
    const updatedCart = cartdata.map((item, i) => {
      if (i === index) {
        const engravingBasePrice = 0;
        const engravingTotal = item.selectedOptions?.engrave?.trim()
          ? engravingBasePrice * newQuantity
          : 0;
        return {
          ...item,
          quantity: newQuantity,
          engravingPrice: engravingTotal,
        };
      }
      return item;
    });

    setCartdata(updatedCart);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
  };

  const removeItem = (index) => {
    const updatedCart = cartdata.filter((_, i) => i !== index);
    setCartdata(updatedCart);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
  };

  const handleViewDetails = (product) => {
    setSelectedProduct(product);
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setSelectedProduct(null);
  };

  const handleCommentChange = (index, value) => {
    setComments(prev => ({ ...prev, [index]: value }));
  };

  const handleOrderRefChange = (index, value) => {
    setReferences(prev => ({ ...prev, [index]: value }));
  };

  const handleEngraveChange = (index, value) => {
    setEngravings(prev => ({ ...prev, [index]: value }));

    const updatedCart = [...cartdata];
    if (!updatedCart[index]) return;

    const qty = Number(updatedCart[index].quantity) || 1;
    const engravingBasePrice = 0;
    const totalEngravingPrice = value.trim() ? engravingBasePrice * qty : 0;

    updatedCart[index].selectedOptions = {
      ...updatedCart[index].selectedOptions,
      engrave: value,
    };
    updatedCart[index].engravingPrice = totalEngravingPrice;

    setCartdata(updatedCart);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
  };

 const getDeliveryDateByStock = (isInStock) => {
  const date = new Date();
  date.setDate(date.getDate() + (isInStock ? 2 : 14));
  return date.toISOString().split("T")[0]; // YYYY-MM-DD
};

 
const handleUpdateCart = () => {
  const updatedCart = cartdata.map((item, index) => {
    const engravingText =
      engravings[index] || item.selectedOptions?.engrave || "";

    return {
      ...item,
      ProductNewprice: applyMarkup(
        item.productCartPrice * selectedCurrency.price || 0
      ),
      selectedOptions: {
        ...item.selectedOptions,
        engrave: engravingText,
      },
      engravingPrice: 0,
      comment: comments[index] || item.comment || "",
      Deliverydate: item.Deliverydate, // 🔴 DO NOT use || ""
      OrdersRef: references[index] || item.OrdersRef || "",
      Orderlogo: uploadedFiles[index]
        ? uploadedFiles[index].name
        : "",
    };
  });

  setCartdata(updatedCart);
  localStorage.setItem("cart", JSON.stringify(updatedCart));

  navigate("/checkout"); // optional
};

  const handleStockChange = (index, inStock) => {
  const newDate = getDeliveryDateByStock(inStock);

  const updatedCart = cartdata.map((item, i) =>
    i === index
      ? { ...item, InStock: inStock, Deliverydate: newDate }
      : item
  );

  setCartdata(updatedCart);
  localStorage.setItem("cart", JSON.stringify(updatedCart));
};



  const handleFileChange = (event, index) => {
    const file = event.target.files[0];
    if (!file) return;

    const ext = file.name.split('.').pop().toLowerCase();
    const allowed = ["jpg", "jpeg", "png"];

    if (!allowed.includes(ext)) {
      alert("Please upload only JPG/JPEG/PNG images");
      return;
    }

    setUploadedFiles(prev => ({ ...prev, [index]: file }));
    setPreviewImages(prev => ({ ...prev, [index]: URL.createObjectURL(file) }));
  };
const getMinDateByStock = (isInStock) => {
  const date = new Date();
  date.setDate(date.getDate() + (isInStock ? 2 : 14));
  return date.toISOString().split("T")[0];
};

  if (!selectedCurrency) return null;

  return (
    <div>
      <div className="home">
        <div id="page" className="hfeed page-wrapper">
          <Header />
          <div id="site-main" className="site-main">
            <div id="main-content" className="main-content">
              <div id="primary" className="content-area">
                <br />
                <div id="content" className="site-content" role="main">
                  <div className="section-padding">
                    <div className="section-container p-l-r">
                      <div className="shop-cart">
                        <div className="row justify-content-center">
                          <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                            <form className="cart-form">
                              <div className="table-responsive">
                                <table className="cart-items table" cellSpacing="0">
                                  <thead>
                                    <tr>
                                      <th>Product</th>
                                      <th rowSpan={2}>Price</th>
                                      <th>Quantity</th>
                                      <th>Subtotal</th>
                                      {/* <th></th> */}
                                      <th>Engrave</th>
                                      <th>Comment</th>
                                      <th>Reference</th>
                                      {/* <th>Logo On Jewellery</th> */}
                                      <th>Delivery Date</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>

                                    {cartdata.length === 0 ? (
                                      <tr>
                                        <td colSpan="9">
                                          <div className="shop-cart-empty">
                                            <div className="notices-wrapper">
                                              <p className="cart-empty">Your cart is currently empty.</p>
                                            </div>
                                            <div className="return-to-shop">
                                              <a className="button" href="/products">Return to shop</a>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    ) : (
                                      cartdata.map((product, index) => (
                                       
                                        <tr key={index}>

                                          <td className="product-thumbnail" style={{textAlign:"center",color:"black"}}>
                                            <a href={`/productdetails/${product.id}?metal=${encodeURIComponent(`${product?.selectedOptions?.metal}`)}${product?.selectedOptions?.shape ? `&shape=${encodeURIComponent(product?.selectedOptions?.shape)}` : ""}`}>
                                              <img width="600" height="600" src={product?.selectedOptions?.productimg} alt={product.productName} />
                                              {product.productName}
                                            </a>
                                          </td>

                                          {/* PRICE WITH MARKUP FIXED */}
                                          <td className="product-price">
                                            <span className="price">
                                            {selectedCurrency?.name === "GBP" ? "" : selectedCurrency?.name}{" "}
                                              {(() => {
                                                let base = Number(product.productCartPrice) || 0;
                                               let updated = applyMarkup(base)*selectedCurrency.price;
                                                return Math.round(updated);
                                              })()}
                                            </span>
                                          </td>

                                          <td className="product-quantity">
                                            <div className="quantity">
                                              <button type="button" className="minus" onClick={() => updateQuantity(index, Math.max(1, product.quantity - 1))}>-</button>
                                              <input type="number" className="qty" min="1" value={product.quantity} onChange={(e) => updateQuantity(index, Number(e.target.value))} />
                                              <button type="button" className="plus" onClick={() => updateQuantity(index, product.quantity + 1)}>+</button>
                                            </div>
                                          </td>

                                          {/* SUBTOTAL WITH MARKUP FIXED */}
                                          <td className="product-subtotal">
                                            <span>
                                             {selectedCurrency?.name === "GBP" ? "$" : selectedCurrency?.name}{" "}
                                              {(() => {
                                                let base = Number(product.productCartPrice) || 0;
                                                let updated = applyMarkup(base)*selectedCurrency.price;
const total = updated * product.quantity + (Number(product.engravingPrice) || 0);
return Math.round(total);
                                              })()}
                                            </span>
                                          </td>

                                          

                                          <td>
                                            {product.engrave && (
                                              <input
                                                type="text"
                                                maxLength={25}
                                                placeholder="(25 letters)"
                                                value={engravings[index] !== undefined ? engravings[index] : product.selectedOptions?.engrave || ""}
                                                onChange={(e) => handleEngraveChange(index, e.target.value)}
                                              />
                                            )}
                                          </td>

                                          <td>
                                            <textarea placeholder="Add a comment" value={comments[index] || product.comment || ""} onChange={(e) => handleCommentChange(index, e.target.value)} />
                                          </td>

                                          <td>
                                            <textarea placeholder="Order Reference" value={references[index] || product.OrdersRef || ""} onChange={(e) => handleOrderRefChange(index, e.target.value)} />
                                          </td>

                                          {/* <td>
                                            <input type="file" className="form-control" accept=".jpg, .jpeg, .png" onChange={(e) => handleFileChange(e, index)} />
                                            {previewImages[index] && (
                                              <img src={previewImages[index]} alt="Preview" style={{ width: "120px", marginTop: "10px", borderRadius: "8px" }} />
                                            )}
                                          </td> */}
                                          <td> <div className="checkout-field">
                                      

<input
  type="date"
  min={getMinDateByStock(product.InStock)} // 🔒 business rule enforced
  value={cartdata[index]?.Deliverydate}
  onChange={(e) => {
    const selected = e.target.value;
    const minAllowed = getMinDateByStock(product.InStock);

    if (selected < minAllowed) {
      setDeliveryError(
        `Delivery date must be on or after ${minAllowed}`
      );
      return;
    }

    setDeliveryError("");

    const updated = cartdata.map((item, i) =>
      i === index ? { ...item, Deliverydate: selected } : item
    );

    setCartdata(updated);
    localStorage.setItem("cart", JSON.stringify(updated));
  }}
/>



                                           
                                            {deliveryError && (
                                              <p style={{ color: "red", fontSize: "13px", marginTop: "4px" }}>{deliveryError}</p>
                                            )}
                                          </div></td>
                                          <td>
                                            <button onClick={() => handleViewDetails(product)} className="cart-toggle-details-btn" type="button">Product Details</button>
                                          </td>

                                          <td className="product-remove">
                                            <button onClick={() => removeItem(index)} className="remove">×</button>
                                          </td>

                                        </tr>
                                      ))
                                    )}
{isPopupOpen && selectedProduct && (
                                      <div className="cart-popup2" style={{ display: "flex" }}>
                                        <div className="cart-popup-content">
                                          <span className="cart-popup-close" onClick={handleClosePopup}>&times;</span>
                                          <h2>Product Details</h2>
                                          <div className="product-and-image">
                                            <div className="product-image">
                                              <img
                                                src={selectedProduct?.selectedOptions?.productimg}
                                                alt={selectedProduct?.productName || "Product"}
                                              />
                                            </div>
                                            <p className="product-name">{selectedProduct.productName}</p>
                                          </div>
                                          <ul className="cart-product-details-list">

                                            {selectedProduct.selectedOptions?.metal && <li><strong>Metal :</strong> {selectedProduct.selectedOptions?.metal}</li>}
                                            {selectedProduct.selectedOptions.ringSize && <li><strong>Ring Size:</strong> {selectedProduct.selectedOptions.ringSize}</li>}
                                            {selectedProduct.selectedOptions?.shape && <li><strong>Shape:</strong> {selectedProduct.selectedOptions.shape}</li>}
                                            {selectedProduct.selectedOptions?.stone && <li><strong>Stone Type:</strong> {selectedProduct.selectedOptions.stone}</li>}
                                            {selectedProduct.selectedOptions?.bandWidth && <li><strong>Band Width:</strong> {selectedProduct.selectedOptions.bandWidth}</li>}
                                            {selectedProduct.centerStone && <li><strong>Center Stone:</strong> {selectedProduct.centerStone}</li>}
                                            {selectedProduct.selectedValues?.Clarity && <li><strong>Clarity:</strong> {selectedProduct.selectedValues.Clarity}</li>}
                                            {selectedProduct.selectedValues?.Certificate && <li><strong>Certificate:</strong> {selectedProduct.selectedValues.Certificate}</li>}
                                            {selectedProduct.selectedValues?.Colour && <li><strong>Color:</strong> {selectedProduct.selectedValues.Colour}</li>}
                                            {selectedProduct.selectedOptions?.carat && <li><strong>Carat:</strong> {selectedProduct.selectedOptions.carat}</li>}
                                            {selectedProduct.backing && <li><strong>Backing:</strong> {selectedProduct.backing}</li>}
                                            {selectedProduct.chainType && <li><strong>Chain Type:</strong> {selectedProduct.chainType}</li>}
                                            {selectedProduct.lengthInches && <li><strong>Length (inches):</strong> {selectedProduct.lengthInches}</li>}
                                            {selectedProduct.chainLength && <li><strong>Chain Length:</strong> {selectedProduct.chainLength}</li>}
                                            {selectedProduct.gemstoneQuality && <li><strong>Gemstone Quality:</strong> {selectedProduct.gemstoneQuality}</li>}
                                            {selectedProduct.bandDepth && <li><strong>Band Depth:</strong> {selectedProduct.bandDepth}</li>}
                                            {selectedProduct.width && <li><strong>Width:</strong> {selectedProduct.width}</li>}
                                            {selectedProduct.selectedValues?.Cutgrade && <li><strong>Cut Grade:</strong> {selectedProduct.selectedValues.Cutgrade}</li>}
                                            {selectedProduct.selectedValues?.Polish && <li><strong>Polish:</strong> {selectedProduct.selectedValues.Polish}</li>}
                                            {selectedProduct.selectedValues?.Symmetry && <li><strong>Symmetry:</strong> {selectedProduct.selectedValues.Symmetry}</li>}
                                            {selectedProduct.selectedValues?.Fluo && <li><strong>Fluo:</strong> {selectedProduct.selectedValues.Fluo}</li>}
                                            {selectedProduct.selectedValues?.ProductCodes && <li><strong>SKU:</strong> {selectedProduct.selectedValues.ProductCodes}</li>}
                                          </ul>

                                        </div>
                                      </div>
                                    )}
                                    <tr>
                                      <td colSpan="8" className="actions">
                                        <br />
                                        <div className="bottom-cart">

                                         

                                          <button type="button" onClick={handleUpdateCart} className="button update-cart">Update Cart & Checkout</button>

                                        </div>
                                      </td>
                                    </tr>

                                  </tbody>
                                </table>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cart;
